import { providersService } from '../services';

export const Screen = async () => {
  const { data } = await providersService.getScreen();
  return data;
};
